import {setCssVariablesProperty} from '@cibsite/ui-components-vue2';

export default function(to, from) {
    setCssVariablesProperty([{variable: '--scroll-behavior', variableProp: 'auto'}]);

    if (to.hash) {
        setCssVariablesProperty([{variable: '--scroll-behavior', variableProp: 'smooth'}]);

        return new Promise((resolve) => {
            setTimeout(() => {
                resolve({selector: to.hash});
            }, 100);
        });
    }

    if (from.path === to.path) {
        return;
    }

    return new Promise((resolve) => {
        setTimeout(() => {
            resolve({x: 0, y: 0});
        }, 100);
    });
};
